























































































































import {
  defineComponent,
  computed,
  ref,
  onBeforeUnmount,
  useStore,
  onMounted,
  useRoute,
  PropType,
  watch,
} from '@nuxtjs/composition-api'
import { throttle } from 'throttle-debounce'
import Intersect from 'vue-intersect'
import queryString from 'query-string'
import BlockBreadCrumbs from '@/components/BlockBreadCrumbs.vue'
import { getColorTitle } from '@/composition/coloredTitle'
import { PULSE_DOMAIN } from '@/contracts/ISectionIframe'
import BlockButtons from '@/components/BlockButtons.vue'
import { buttonsAction } from '@/composition/buttons'
import {
  ButtonAction,
  ButtonHeroActionType,
} from '@/contracts/ButtonHeroAction'
import { AdaptiveImageMq } from '@/contracts/AdaptiveImage'
import AdaptiveImage from '@/components/ImagesBlocks/AdaptiveImage.vue'

export default defineComponent({
  name: 'BlockProductHero',
  components: {
    AdaptiveImage,
    BlockButtons,
    BlockBreadCrumbs,
    BlockVideoPopup: () => import('@/components/BlockVideoPopup.vue'),
    Intersect,
  },
  props: {
    roundImage: {
      type: Boolean,
      default: false,
    },
    isHeroAbout: {
      type: Boolean,
      default: false,
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
    needBreadCrumbs: {
      type: Boolean,
      default: false,
    },
    isMobImageHidden: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    additionalText: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    videoLink: {
      type: String,
      default: '',
    },
    imageCol: {
      type: Number,
      default: 7,
    },
    chipText: {
      type: String,
      default: '',
    },
    buttonActions: {
      type: Array as PropType<ButtonAction[]>,
      default: () => [],
    },
    adaptiveImage: {
      type: Object as PropType<AdaptiveImageMq | null>,
      default: null,
    },
  },
  setup(props) {
    const store = useStore()
    const route = useRoute()
    const { clickHandler } = buttonsAction()
    const companyQuery = computed(() => route.value.query.company)
    const buyWithDiscountButton = computed<ButtonAction | null>(() => {
      const firstButton = props.buttonActions?.[0]
      if (!firstButton) return null
      return {
        ...firstButton,
        label: 'Купить со скидкой',
        type: 'link',
        url: '#calc',
      }
    })

    const displayButtonActions = computed(() =>
      companyQuery.value && buyWithDiscountButton.value
        ? [buyWithDiscountButton.value]
        : props.buttonActions
    )
    const newButtonActions = ref([])
    const needBtnSide = ref<ButtonAction>()
    const timeoutId = ref()
    if (displayButtonActions.value) {
      newButtonActions.value = displayButtonActions.value.map((item) => {
        if (item.type === 'scrollToAgentsForm') needBtnSide.value = item
        return item
      })
    }
    const toggleVideoPopup = ref(false)
    const showButton = ref(false)
    const formView = ref(true)
    const clickShowButton = ref(true)
    const buttonActionType = ButtonHeroActionType
    const compLgCol = computed(() => {
      let colLg
      if (props.isHeroAbout && props.isLarge) {
        colLg = 7
      } else if (!props.isHeroAbout && !props.isLarge) {
        colLg = 12 - props.imageCol
      } else {
        colLg = 9
      }
      return colLg
    })

    const onClick = (button: ButtonAction) => {
      clickShowButton.value = false
      const { type, eventAction, eventCategory, jsCode } = button || {}
      clickHandler(type, eventAction, eventCategory, jsCode)
      setTimeout(() => {
        clickShowButton.value = true
      }, 2000)
    }
    const sizes = {
      sm: [343, 200],
      md: [762, 360],
      lg: [762, 360],
    }

    const onScroll = throttle(50, () => {
      if (process.browser && needBtnSide.value) {
        if (!document.querySelector('.agents')) return
        const position = document
          .querySelector('.agents')
          .getBoundingClientRect()
        formView.value =
          position.top < window.innerHeight && position.bottom >= 0
      }
    })
    onMounted(() => {
      if (process.browser && needBtnSide.value && props.buttonActions) {
        window.addEventListener('scroll', onScroll)
      }
    })
    onBeforeUnmount(() => {
      if (process.browser) {
        window.removeEventListener('scroll', onScroll)
      }
    })

    const pageQuery = computed(() => {
      if (!process.browser) return ''
      return queryString.stringify(route.value.query)
    })

    const injectQueryParameters = (link) => {
      if (!link.href.includes(PULSE_DOMAIN)) return
      const query = pageQuery.value
      const splitUrl = link.href?.split('#')
      link.href = `${splitUrl[0] || ''}${
        query && !link.href.includes(query)
          ? link.href.includes('?')
            ? '&'
            : '?'
          : ''
      }${link.href && !link.href.includes(query) ? query : ''}${
        splitUrl[1] ? `#${splitUrl[1]}` : ''
      }`
    }

    const pageContentObserver = ref<MutationObserver | null>(null)

    watch(
      () => route.value.fullPath,
      () => {
        if (!process.browser) return
        clearTimeout(timeoutId.value)
        timeoutId.value = setTimeout(() => {
          const links = document.querySelectorAll('a')
          links.forEach(injectQueryParameters)
        }, 0)

        const target = document.querySelector('.page-wrapper')

        if (target) {
          const config: MutationObserverInit = {
            subtree: true,
            childList: true,
          }

          if (pageContentObserver.value) {
            pageContentObserver.value.disconnect()
          }

          pageContentObserver.value = new MutationObserver(
            (records: MutationRecord[]) => {
              for (const rec of records) {
                for (const node of rec.addedNodes) {
                  if (node.nodeType !== Node.ELEMENT_NODE) continue
                  if (node.tagName === 'A') {
                    injectQueryParameters(node)
                  } else {
                    node.querySelectorAll('a').forEach(injectQueryParameters)
                  }
                }
              }
            }
          )
          pageContentObserver.value.observe(target, config)
        }
      },
      { immediate: true }
    )

    const onEnter = () => {
      showButton.value = false
    }

    const onLeave = () => {
      showButton.value = true
    }

    const showVideoBtn = computed(
      () => !props.isHeroAbout && props.videoLink && props.image
    )

    const onVideoBtnClick = () => {
      toggleVideoPopup.value = true
      store.commit('settings/SET_HIDE_HEADER', true)
    }

    const onVideoBlockClose = () => {
      toggleVideoPopup.value = false
      store.commit('settings/SET_HIDE_HEADER', false)
    }

    const classObject = computed(() => {
      return [
        (props.isHeroAbout && !props.isLarge) || props.isHeroAbout
          ? 'title--h1'
          : 'title--h2',
        props.isHeroAbout
          ? props.buttonActions && props.isHeroAbout
            ? 'about-title-btn'
            : 'no-margin'
          : '',
      ]
    })

    return {
      onVideoBtnClick,
      onVideoBlockClose,
      showVideoBtn,
      toggleVideoPopup,
      classObject,
      needBtnSide,
      showButton,
      formView,
      clickShowButton,
      onEnter,
      onLeave,
      buttonActionType,
      compLgCol,
      getColorTitle,
      onClick,
      sizes,
      newButtonActions,
      displayButtonActions,
      companyQuery,
    }
  },
})
